export const formatCpfCnpj = (value) => {
  if (!value) return ''
  const sanitized = value.toUpperCase().replace(/[.\-/]/g, '')
  if (sanitized.length === 14) {
    return sanitized.replace(
      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
      '$1.$2.$3/$4-$5',
    )
  }
  const digits = value.replace(/[^\d]/g, '')
  if (digits.length === 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  return value
}
